export default {
  name: "top-product-popup",
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedImageIndex: 0
    };
  },
  computed: {
    itemData() {
      return this.product?.itemData || {};
    },
    media() {
      return this.itemData.media || [];
    },
    variations() {
      return this.itemData.variations || [];
    },
    cashbacks() {
      return this.itemData.cashbacks || [];
    },
    shop() {
      return this.itemData.shop || {};
    },
    itemSelectionGroup() {
      return this.product?.itemSelectionGroup || {};
    },
    selectedImage() {
      return this.media[this.selectedImageIndex] || {};
    },
    deliveryTypes() {
      return this.itemData.deliveryTypes || [];
    },
    categoryIds() {
      return this.itemData.categoryIds || [];
    },
    itemSelections() {
      return this.itemData.itemSelections || [];
    },
    variationHeaders() {
      return [
        { text: "SKU", value: "sku", sortable: false },
        { text: "EAN", value: "ean", sortable: false },
        { text: "Purchase Price", value: "purchasePrice", sortable: false, align: "center" },
        { text: "Selling Price", value: "sellingPrice", sortable: false, align: "center" },
        { text: "Discounted Price", value: "discountedPrice", sortable: false, align: "center" },
        { text: "Quantity", value: "quantity", sortable: false, align: "center" },
        { text: "Reserved", value: "reservedQuantity", sortable: false, align: "center" },
        { text: "Properties", value: "properties", sortable: false },
        { text: "Discounts", value: "discounts", sortable: false }
      ];
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    selectImage(index) {
      this.selectedImageIndex = index;
    },
    formatDate(date) {
      if (!date) return "-";
      return new Date(date).toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit"
      });
    },
    getCashbackTypeLabel(type) {
      const labels = {
        OOBLEE_YELLOW: "Ooblee Yellow",
        OOBLEE_DROPS: "Ooblee Drops"
      };
      return labels[type] || type;
    },
    getCashbackTypeIcon(cashbackType) {
      const icons = {
        AMOUNT_PER_ORDER: "mdi-cash",
        PAYMENT_PERCENT: "mdi-percent"
      };
      return icons[cashbackType] || "mdi-gift";
    }
  }
};
